import { render } from "./StepPage.vue?vue&type=template&id=3797496a&scoped=true"
import script from "./StepPage.vue?vue&type=script&lang=js"
export * from "./StepPage.vue?vue&type=script&lang=js"

import "./StepPage.vue?vue&type=style&index=0&id=3797496a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3797496a"]])

export default __exports__